/** Tailwind classes for Pokémon type badge pills (tinted background + matching text). */
export const TYPE_BADGE_COLORS: Record<string, string> = {
  fire:     "bg-orange-500/15 text-orange-400",
  water:    "bg-blue-500/15 text-blue-400",
  grass:    "bg-green-500/15 text-green-400",
  electric: "bg-yellow-500/15 text-yellow-400",
  psychic:  "bg-pink-500/15 text-pink-400",
  ice:      "bg-cyan-500/15 text-cyan-300",
  dragon:   "bg-indigo-500/15 text-indigo-400",
  dark:     "bg-gray-500/15 text-gray-400",
  fairy:    "bg-pink-300/15 text-pink-300",
  normal:   "bg-gray-400/15 text-gray-300",
  fighting: "bg-red-500/15 text-red-400",
  flying:   "bg-sky-500/15 text-sky-400",
  poison:   "bg-purple-500/15 text-purple-400",
  ground:   "bg-amber-600/15 text-amber-500",
  rock:     "bg-amber-400/15 text-amber-400",
  bug:      "bg-lime-500/15 text-lime-400",
  ghost:    "bg-violet-500/15 text-violet-400",
  steel:    "bg-slate-400/15 text-slate-300",
};

/** Tailwind text-only classes for Pokémon type labels (no background). */
export const TYPE_TEXT_COLORS: Record<string, string> = {
  fire:     "text-orange-400",
  water:    "text-blue-400",
  grass:    "text-green-400",
  electric: "text-yellow-400",
  psychic:  "text-pink-400",
  ice:      "text-cyan-300",
  dragon:   "text-indigo-400",
  dark:     "text-gray-400",
  fairy:    "text-pink-300",
  normal:   "text-gray-300",
  fighting: "text-red-500",
  flying:   "text-sky-400",
  poison:   "text-purple-400",
  ground:   "text-amber-600",
  rock:     "text-amber-400",
  bug:      "text-lime-400",
  ghost:    "text-violet-400",
  steel:    "text-slate-300",
};
